import { usePrizeFormat } from 'src/hooks/usePrizeFormat';
import { GradientTypography } from '../../gradients/GradientTypography';

export type PrizeProps = {
  prize: { amount: number; currency: string };
  rank: number;
};

export const Prize = ({ prize, rank }: PrizeProps) => {
  const prizeFormatted = usePrizeFormat(
    prize || { amount: 0, currency: 'USD' },
  );

  return (
    <GradientTypography
      gradientColor="success.vertical"
      variant={rank > 3 ? 'body2' : 'body1'}
      {...(rank <= 3 && { sx: { fontWeight: 700 } })}
    >
      {prizeFormatted}
    </GradientTypography>
  );
};
